/**
 * SSR-safe, guarded `localStorage` wrapper.
 *
 * Direct `localStorage` access throws in SSR / private-mode / storage-disabled
 * contexts. All access goes through these helpers so a single failure can never
 * crash the app. See CLEANUP.md / CLEANUP_JOBS.md CATEGORY 3.7.
 */

const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export function getItem(key: string): string | null {
  if (!isBrowser) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setItem(key: string, value: string): void {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* storage full / disabled — ignore */
  }
}

export function removeItem(key: string): void {
  if (!isBrowser) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

// ─── Storage keys (co-located so they're not scattered as inline strings) ───
export const COOKIE_CONSENT_KEY = 'mondivago_cookie_consent_v1';
export const LS_DISMISSED_KEY = 'mondivago:onboarding-dismissed';
export const LS_EXPLORE_KEY = 'mondivago:onboarding-explored';
export const LS_PARTNER_MORD_SEEN_KEY = 'mondivago:partner-mord-modal-seen';
export const LS_SUPPLIER_MORD_SEEN_KEY = 'mondivago:supplier-mord-modal-seen';
export const ONBOARDING_COMPLETED_KEY_PREFIX = 'mondivago:onboarding-completed:';
